/* eslint-disable import/prefer-default-export */
export enum Logs {
  apiRequestFailure = 'API_REQUEST_FAILURE',
  apiBadRequestFailure = 'API_BAD_REQUEST_FAILURE',
  apiUserTokenFailure = 'API_USER_TOKEN_FAILURE',
  apiTimeoutFailure = 'API_TIMEOUT_FAILURE',
  apiRequestException = 'API_REQUEST_EXCEPTION',
  apiServiceAuthFailure = 'API_SERVICE_AUTH_FAILURE',
  apiAuthFailure = 'API_AUTH_FAILURE',
  i18nFailure = 'I18N_FAILURE',
  i18nJSONParseFailure = 'I18N_JSON_PARSE_FAILURE',
  componentUnhandledException = 'COMPONENT_UNHANDLED_EXCEPTION',
  domManipulationException = 'DOM_MANIPULATION_EXCEPTION',
  badRequestException = 'BAD_REQUEST_EXCEPTION',
  metricsFailure = 'METRICS_FAILURE',
  weblabServiceFailure = 'WEBLAB_SERVICE_FAILURE',
  richTextEditorFailure = 'RICH_TEXT_EDITOR_FAILURE',
  webVitalsFailure = 'WEB_VITALS_FAILURE',
  // Debug log
  discussionPostError = 'DISCUSSION_POST_ERROR',

}

export enum MethodName {
  searchRequests = 'SEARCH_REQUESTS',
  searchListing = 'SEARCH_LISTING',
  weblabTrigger = 'WEBLAB_TRIGGER',
  apiRequest = 'API_REQUEST',
  userClick = 'USER_CLICK',
  userChange = 'USER_CHANGE',
  pageLoad = 'PAGE_LOAD',
  userOnboarding = 'USER_ONBOARDING',
}

export enum Pages {
  home = 'HOME',
  preferences = 'PREFERENCES',
  profile = 'PROFILE',
  notifications = 'NOTIFICATIONS',
  faq = 'FAQ',
  guidelines = 'GUIDELINES',
  searchListing = 'SEARCH_LISTING',
  createDiscussion = 'CREATE_DISCUSSION',
  threadDetail = 'THREAD_DETAIL',
  groupListing = 'GROUP_LISTING',
  releaseNotes = 'RELEASE_NOTES',
  userOnboarding = 'USER_ONBOARDING',
  groups = 'GROUPS',
}

export enum NavigationCardTypes {
  categories = 'CATEGORIES',
  faq = 'FAQ',
  guidelines = 'GUIDELINES',
  termsOfUse = 'TERMS_OF_USE',
  privacyNotice = 'PRIVACY_NOTICE',
  reportAbuse = 'REPORT_ABUSE',
  releaseNotes = 'RELEASE_NOTES',
}

export enum ButtonTypes {
  viewAllDiscussions = 'VIEW_ALL_DISCUSSIONS',
  saveDefaultPreference = 'SAVE_DEFAULT_PREFERENCE',

  // Discussion listing container
  postAuthor = 'POST_AUTHOR',
  postTitle = 'POST_TITLE',

  // App header
  myProfile = 'MY_PROFILE',
  signIn = 'SIGN_IN',
  createDiscussion = 'CREATE_DISCUSSION',
  forumsMP = 'FORUMS_MP',
  navbar = 'NAVBAR',
  searchBar = 'SEARCH_BAR',

  // Home page
  discussionsFilter = 'DISCUSSIONS_FILTER',
  updatePreferences = 'UPDATE_PREFERENCES',

  // Thread detail
  OpPostAuthor = 'OP_POST_AUTHOR',
  replyPostAuthor = 'REPLY_POST_AUTHOR',
  repliesFilter = 'REPLIES_FILTER',
  postCategory = 'POST_CATEGORY',
  displayRepliesToggle = 'DISPLAY_REPLIES_TOGGLE',
  imageCarouselOpen = 'IMAGE_CAROUSEL_OPEN',
  imageCarouselClose = 'IMAGE_CAROUSEL_CLOSE',
  imageCarouselNext = 'IMAGE_CAROUSEL_NEXT',
  imageCarouselPrevious = 'IMAGE_CAROUSEL_PREVIOUS',

  // Notifications
  notificationFilter = 'NOTIFICATION_FILTER',
  markAllAsRead = 'MARK_ALL_AS_READ',
  viewMoreNotifications = 'VIEW_MORE_NOTIFICATIONS',
  notificationId = 'NOTIFICATION_ID',

  // Preference page
  notificationPreference = 'NOTIFICATION_PREFERENCE',
  notificationPreferenceSubmit = 'NOTIFICATION_PREFERENCE_SUBMIT',

  // Groups page
  groupSelection = 'GROUP_SELECTION',

  // Profile page
  updateProfileInfo = 'UPDATE_PROFILE_INFO',
  updateProfileImage = 'UPDATE_PROFILE_IMAGE',
  viewStoreNames = 'VIEW_STORE_NAMES',

  // User onboarding page
  welcomeNext = 'WELCOME_NEXT',
  usernameNext = 'USERNAME_NEXT',
  previewNext = 'PREVIEW_NEXT',
  previewBack = 'PREVIEW_BACK',
  category = 'CATEGORY',
  allCategories = 'ALL_CATEGORIES',
  skipSaveCategories = 'SKIP_SAVE_CATEGORIES',
  categoriesBack = 'CATEGORIES_BACK',
  savePreferences = 'SAVE_PREFERENCES',
  viewProfile = 'VIEW_PROFILE',
  viewHomepage = 'VIEW_HOMEPAGE',
  displaynameSelection = 'DISPLAYNAME_SELECTION',
  viewPreferences = 'VIEW_PREFERENCES',
}

export enum MetricKeys {
  navigationCard = 'NAVIGATION_CARD',
  categoryCard = 'CATEGORY_CARD',
  button = 'BUTTON',
  click = 'CLICKS',
  postIndex = 'POST_INDEX',
  unavailableDisplayName = 'UNAVAILABLE_DISPLAY_NAME',
  invalidDisplayName = 'INVALID_DISPLAY_NAME',
  isSelected = 'IS_SELECTED',
  validOldIdentities = 'VALID_OLD_IDENTITIES',
  invalidOldIdentities = 'INVALID_OLD_IDENTITIES',
}

export enum MetricValues {
  clear = 'CLEAR',
}

export enum MetricName {
  jsError = 'JS_ERROR',
  fetchRequest = 'FETCH_REQUEST',
}
